<template>
    <div>
        <div class="columns"><div class="column is-narrow" style="align-self: center; padding-left: 85px">Bildtitel: </div><div class="column" style="padding-right: 85px"><input type="text" id="title" class="input" v-model="title"></div></div>

        <cropper
            ref="cropper"
            style="height: 80vh"
            class="cropper"
            :src="image.src"
            :stencil-props="{
		        aspectRatio: component.props.cropRatio,
	}"

            @change="change"
        ></cropper>
    </div>

</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import jsonToFormData from "json-form-data";
import axios from "axios";

export default {
    data () {
        return {
            title: this.image.name,
        }
    },

    props: {
        image: {type: Object},
        component: {type: Object},
    },

    methods: {
        change({coordinates, canvas}) {
        },

        upload (original = false)
        {
            const { canvas } = this.$refs.cropper.getResult();
            if(original) {
                let formDataO = {
                    title: this.title,
                    orderConcept: window.location.pathname.includes('concepts') ? '/api'+ window.location.pathname : null,
                    destination: window.location.pathname.includes('destinations') ? '/api' + window.location.pathname : null,
                    folder : 'Kundenbilder',
                    type: 'photo',
                };
                formDataO = jsonToFormData(formDataO);
                formDataO.append('user_file_upload', this.image.original)
                axios.post(
                    '/api/images/upload', formDataO);
            }
            if (canvas) {
                let formData = {
                    title: this.title,
                    type: this.component.props.filterParams.type,
                    ...this.component.props.maxFileSize && { maxFileSize: this.component.props.maxFileSize }
                };

                // Handle avatar upload with custom filename and folder
                if (this.component.props.filterParams.type === 'avatar') {
                    // Get username from props
                    const username = this.component.props.username;
                    if (!username) {
                        console.error('No username provided for avatar upload');
                        return;
                    }
                    formData.customFilename = `${username}.png`;
                    formData.customFolder = 'public/clientSpecific/img_user';
                } else {
                    // Regular image upload
                    formData.orderConcept = window.location.pathname.includes('concepts') ? '/api'+ window.location.pathname : null;
                    formData.destination = window.location.pathname.includes('destinations') ? '/api' + window.location.pathname : null;
                    formData.folder = 'Homepage';
                }

                formData = jsonToFormData(formData);

                canvas.toBlob(blob => {
                    formData.append('user_file_upload', blob);
                    this.$emit('startUpload', axios.post('/api/images/upload', formData))
                }, 'image/png')
            }
        },
    },
    components: {
        Cropper
    }
}
</script>

